import React, { useState, useEffect, useContext } from 'react';
import AppContext from "../../../Store/AppContext";
import { ObterUrlMidia } from '../../../Services/WhatsApp';
import "./MensagemSticker.css";


const MensagemSticker = ({ mensagem }) => {
    const { contaWhatsAppDefault } = useContext(AppContext);

    const mediaId = mensagem.logConversasWhatsAppMediaId;
    const initialUrl = mensagem._mediaUrl;

    const [url, setUrl] = useState(initialUrl || null);
    const [loading, setLoading] = useState(!initialUrl);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        if (initialUrl || !mediaId) return;

        setLoading(true);
        ObterUrlMidia(contaWhatsAppDefault, mediaId).then(({ success, url }) => {
            if (success && url) setUrl(url);
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }, [mediaId]);

    if (loading) return <div>[Carregando sticker...]</div>;
    if (!url) return <div>[Sticker não disponível]</div>;

    return (
        <>
            <img
                src={url}
                alt="Sticker WhatsApp"
                className="sticker-whatsapp"
                onClick={() => setModalOpen(true)}
            />

            {modalOpen && (
                <div className="modal-imagem-overlay" onClick={() => setModalOpen(false)}>
                    <img
                        src={url}
                        alt="Sticker em zoom"
                        className="modal-sticker"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <span className="modal-close" onClick={() => setModalOpen(false)}>✕</span>
                </div>
            )}
        </>
    );
};

export default MensagemSticker;
